/* eslint-disable react/react-in-jsx-scope */
import { Box, Container, Typography, Grid } from "@mui/material";
import "./homepage-new.scss";
import CardHome from "../../common/components/card-home-component/card-home";

// data for carousel, card & stepCard sections
import { cardData } from "../../data/homepageData";

export default function FourthSectionHome() {
  const handleReadMore = () => {
    // handle more needs to be implemented in coming build
  };
  return (
    <Box
      sx={{
        bgcolor: "#F8F2E5CC",
        padding: "1rem",
        height: "60%",
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        paddingBottom: "4rem !important",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            textAlign: "center",
            marginTop: "2rem",
            fontWeight: 600,
            fontSize: { xs: "24px", md: "32px", lg: "34px" },
            lineHeight: { xs: "28px", md: "36px", lg: "40px" },
            color: "#104145",
          }}
        >
          Why <span style={{ color: "#9F7F2C" }}>Choose MemorialGo</span>
        </Typography>

        <Typography
          sx={{
            fontWeight: 400,
            fontStyle: "normal",
            fontSize: { xs: "28px", sm: "36px", md: "64px" },
            lineHeight: "100%",
            letterSpacing: "0%",
            textAlign: "center",
            color: "#104145",
            marginTop: "1rem",
          }}
        >
          Everything You Need,&nbsp;
          <span style={{ color: "#9F7F2C" }}>Thoughtfully Connected</span>
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", md: "18px" },
            mt: 1.5,
          }}
        >
          MemorialGo isn’t just a list of providers — it’s a central hub that
          brings everything together, so nothing falls through the cracks.
        </Typography>

        <Container maxWidth="lg" sx={{ mt: 6 }}>
          <Grid container spacing={2}>
            {cardData.map((card, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <CardHome
                  icon={card.icon}
                  title={card.title}
                  description={card.description}
                  onReadMore={handleReadMore}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
